import * as React from 'react';
import ServicesFactory from './ServicesFactory';
import { useSelector } from 'react-redux';
import { NASProductCategory, OrderStatus } from '@websky/graphql';
import { useConfig } from '../../../../../context';
import { getOrderStatus } from '../../../../store/order/selectors';
const Services = ({ services, segmentId }) => {
    const status = useSelector(getOrderStatus), { nasServiceUpsaleForConfirmedOrder } = useConfig().Engine;
    const filteredServices = services.filter(service => {
        if (service.type === NASProductCategory.fast_track ||
            service.type === NASProductCategory.lounge ||
            service.type === NASProductCategory.meet_and_greet ||
            service.type === NASProductCategory.vip) {
            return (status === OrderStatus.New ||
                status === OrderStatus.Booked ||
                service.selectedServices.length > 0 ||
                (nasServiceUpsaleForConfirmedOrder && status !== OrderStatus.Cancelled));
        }
        return true;
    });
    return (React.createElement(React.Fragment, null, filteredServices.map(service => (React.createElement(ServicesFactory, { key: `${service.type}/${segmentId}`, service: service, segmentId: segmentId })))));
};
export default Services;
